import Image from 'next/image'

const Intro = ({ topBG, data }) => {
    return (
        <>
            <Image
                style={{ position: 'absolute', bottom: 0, zIndex: 1 }}
                src={topBG}
                alt=''
            />
            {data && data.intro && (
                <div className='news-details__top-bg'>
                    <Image
                        itemProp='image'
                        className=''
                        width={1440}
                        height={700}
                        src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${data.intro}`}
                        alt='intro'
                    />
                </div>
            )}
        </>
    )
}

export default Intro
